<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <CadastroOperadora />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import CadastroOperadora from "./../Components/Cadastros/CadastroOperadora.vue";
export default {
  name: "RegisterHotel",
  components: {
    CadastroOperadora,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
